export const orderContant = {
    dilivery: {
      fast: "FAST",
      gojek: "GO_JEK",
    },
    payment: {
      later_money: "Thanh toán khi nhận hàng",
      VnPay: "Thanh toán bằng VnPay",
    },
  };
  